import { useMemo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import config from 'constants/config'
import { agentHubOrSubBrandConfig } from 'agentHub/constants'
import TextLink from 'LuxKit/TextLink'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import type { PageBannerCarouselItem } from 'LuxKit/Banners/types'

function useAgentHubBannerItems(): Array<PageBannerCarouselItem> {
  const intl = useIntl()
  const isLoggedIn = useAppSelector(selectLoggedIn)
  const agentHubPhoneNumber = useAppSelector(state => state.geo.currentContact?.local.humanReadable ?? '')

  return useMemo(() => {
    if (!config.agentHub.isEnabled) return []

    const items: Array<PageBannerCarouselItem> = []

    // TODO remove this banner once middle east air space is cleared https://aussiecommerce.atlassian.net/browse/LEAH-1451
    if (isLoggedIn) {
      items.push({
        id: 'agent-hub-warning',
        kind: 'warning',
        children: intl.formatMessage(
          {
            id: 'rBuRvway7Hef5Deqc2YU',
            defaultMessage: 'We are monitoring the evolving situation in the Middle East. If any of your upcoming bookings may be affected, please contact our team on {phoneNumber} for support.',
            description: 'Agent hub Middle East situation warning banner in page header',
          },
          { phoneNumber: agentHubPhoneNumber },
        ),
      })
    }

    items.push({
      id: 'agent-hub-support',
      kind: 'promotional-primary',
      children: <FormattedMessage
        id="dWKLR3ckHKyE3edGxGcI"
        defaultMessage="Need help? Email <emailLink>{supportEmail}</emailLink>"
        description="Agent hub support email banner in the page header in the site header"
        values={{
          supportEmail: agentHubOrSubBrandConfig.supportEmail,
          emailLink: (chunks) => <TextLink href={`mailto:${agentHubOrSubBrandConfig.supportEmail}`}>{chunks}</TextLink>,
        }}
      />,
    })

    return items
  }, [isLoggedIn, agentHubPhoneNumber, intl])
}

export default useAgentHubBannerItems
